import { render } from "./KanbanContent.vue?vue&type=template&id=1116a209"
import script from "./KanbanContent.vue?vue&type=script&lang=js"
export * from "./KanbanContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__